import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Petrol Ofisi',
  logo: { name: 'Petrol Ofisi', src: '/logo/petrolofisicard.png' },
  portrait: { src: '/photo/portrait-mehmet-ali-gulsen.png', alt: 'Mehmet Ali Gülşen' },
  quote: [
    'We collaborate with Digitopia because they are best-in-class and bring a '
    + 'customer-centric approach to our partnership. Their continuous support, such as '
    + 'measuring our progress every three months and crafting tailored digital roadmaps, has '
    + 'been invaluable.',
    'By engaging our employees in the digitalization journey and fostering their active '
    + 'involvement, Digitopia has helped us lay a strong foundation for transformation. With '
    + 'their expertise and ongoing support, we are confident in achieving our digital '
    + 'transformation goals.',
  ],
  attribution: 'Mehmet Ali Gülşen, Chief Digital Transformation Officer',
  story: 'petrol-ofisi-group',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 7
